import { createTypes } from '../../utils/helpers';

const MODELS_FETCH_MODELS: any = createTypes('MODELS_FETCH_MODELS');
const MODELS_SET_ROWS_PER_PAGE = 'MODELS_SET_ROWS_PER_PAGE';
const MODELS_SET_PAGE = 'MODELS_SET_PAGE';
const MODELS_CLEAR_PAGINATION_INFO = 'MODELS_CLEAR_PAGINATION_INFO';
export {
  MODELS_FETCH_MODELS,
  MODELS_SET_ROWS_PER_PAGE,
  MODELS_SET_PAGE,
  MODELS_CLEAR_PAGINATION_INFO,
};
